module.exports = __webpack_public_path__ + "img/credito_mora.79d17056.png";